import React from "react";

import { Box, Modal, Typography } from "@mui/material";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

const Revoke = ({ open, onClose, onConfirm, loading = false }) => {
  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="revoke-support-token-title"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(31, 42, 68, 0.42)",
          },
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",

          width: "430px",
          maxWidth: "calc(100vw - 32px)",

          display: "flex",
          flexDirection: "column",

          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 18px 50px rgba(25, 35, 70, 0.25)",
          outline: "none",
        }}
      >
        {/* Content */}
        <Box
          sx={{
            px: "24px",
            py: "24px",
          }}
        >
          <Typography
            id="revoke-support-token-title"
            sx={{
              color: "#172B68",
              fontSize: "20px",
              fontWeight: 700,
            }}
          >
            Revoke support access?
          </Typography>

          <Typography
            sx={{
              mt: "18px",
              color: "#687184",
              fontSize: "14px",
              lineHeight: 1.5,
            }}
          >
            D-Link support will lose access immediately. You can generate a new
            token afterward.
          </Typography>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            px: "24px",
            py: "16px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            borderTop: "1px solid #E5E9F2",
            backgroundColor: "#FAFBFD",
          }}
        >
          <OutlineButton
            disabled={loading}
            onClick={onClose}
            width="80px"
            height="32px"
          >
            Cancel
          </OutlineButton>

          <SolidButton
            disabled={loading}
            onClick={onConfirm}
            width="100px"
            height="32px"
          >
            {loading ? "Revoking..." : "Confirm"}
          </SolidButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default Revoke;
